import { Box, Grid, Hidden, IconButton, useMediaQuery } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'
import Container from '../../components/layout_micro/container'
import iconoAuto from '../../../assets/icono-autotoma.svg'
import ResponsiveFonts from '../../components/layout_micro/responsiveFonts'
import { Phone, WhatsApp } from '@material-ui/icons'

const Picture = styled.img`
  width: 110px;
  @media screen and (max-width:1750px) {
    width: 90px;
  }
  @media screen and (max-width:1550px) {
    width: 80px;
  }
  @media screen and (max-width:600px) {
    width: 50px;
  }
`
const Body = styled.div`
  margin: 3em 0px;
`
const DataWrapper = styled.div`
  flex-grow: 1;
  margin-left: 2em;
  @media screen and (max-width:600px) {
    margin-left: 1em;
  }
`
const Title = styled.div`
  font-size: 3.5em;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
  line-height: 1em;
  @media screen and (max-width:600px) {
    font-size: 3em;
  }
`

const SubTitle = styled.div`
  font-size: 2.5em;
  color: var(--second);
  font-family: 'imlmedium';
  line-height: 1em;
  @media screen and (max-width:600px) {
    font-size: 1.8em;
  }
  @media screen and (max-width:450px) {
    font-size: 1.4em;
  }
`

const MessageWrapper = styled.div`
  margin-top: 3em;
`

const INdicationTitle = styled.div`
  font-size: 1.4em;
  background-color: var(--first);
  font-family: 'imlmedium';
  line-height: 1em;
  color: #fff;
  display: inline;
  padding: .1em .5em;
  margin-bottom: 2em;
`

const IdicationsItem = styled.div`
  padding-left: 1em;
  position: relative;
  font-size: 1.2em;
  line-height: 1.3em;
  margin-bottom: .4em;
  color: var(--first);
  font-family: 'imlmedium';
  ::before {
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: var(--second);
    top: .5em;
    left: 0px;
  }
`

const MessageGrid = styled(Grid)`
  margin-top: 1.1em;
`
const Href = styled.a`
  color: var(--first);
  text-decoration: none;
`
const IconContact = styled(IconButton)`
  background: var(--second);
  padding: 5px;
  margin-right: 10px;
  svg {
    color: #fff;
    font-size: 20px;
  }
  :hover {
    background: var(--first);
  }
  @media screen and (max-width:660px) {
    padding: 5px;
    margin-right: 5px;
    svg {
      font-size: 15px;
    }
  }
`
const ContactItem = styled(Grid)`
  font-size: 1.2em;
  cursor: pointer;
  font-family: 'imlbold'; font-weight: bold;
`

const Header = props => {
  const isMobile = useMediaQuery('(max-width:650px)')
  const isXS = useMediaQuery('(max-width:600px)')

  const messageBody = (
    <MessageWrapper>
      <INdicationTitle>Indicaciones generales</INdicationTitle>
      <MessageGrid container spacing={isXS ? 0 : isMobile ? 2 : 5}>
        <Grid item sm={6} xs={12}>
          <IdicationsItem>
            Horario de asesoría para agendar tu cita: <Hidden xsDown><br /></Hidden>7:00 am a 6:00 pm.
          </IdicationsItem>
          <IdicationsItem>
            Es obligatorio completar los pasos del 1 al 5.
          </IdicationsItem>
          <IdicationsItem>
            Es importante que no omitas ningún paso para
            poder dar seguimiento a tu petición de manera
            oportuna.
          </IdicationsItem>
        </Grid>
        <Grid item sm={6} xs={12}>
          <IdicationsItem>
            Para esta modalidad NO solo aplica para
            pacientes con vehículo.
          </IdicationsItem>
          <IdicationsItem>
            La toma de la muestra solo aplica en la Sucursal UNIDAD ARCOS Dirección: Ramón Rodríguez Familiar #36, Jardines de Querétaro, Querétaro, Qro. 76020.
          </IdicationsItem>
          <IdicationsItem>
            En caso de no estar disponible el horario
            de preferencia, comunícate con nosotros:
          </IdicationsItem>
          <Box mt={2} paddingLeft='1.6em'>
            <Grid container spacing={isMobile ? 0 : 2}>
              <ContactItem xs={7}>
                <Href href='tel:4422130898' target='_blank'>
                  <IconContact size='small'>
                    <Phone />
                  </IconContact>
                  Tel. 442 213 0898
                </Href>
              </ContactItem>
              <ContactItem xs={5}>
                <Href href='https://api.whatsapp.com/send?phone=5214428173500' target='_blank'>
                  <IconContact size='small'>
                    <WhatsApp />
                  </IconContact>
                  WhatsApp
                </Href>
              </ContactItem>
            </Grid>
          </Box>
        </Grid>
      </MessageGrid>
    </MessageWrapper>
  )

  return (
    <ResponsiveFonts>
      <Container id='init'>
        <Body>
          <Grid container alignItems='flex-start' wrap='nowrap'>
            <Picture src={iconoAuto} />
            <DataWrapper>
              <div>
                <Title>Módulo de Atención Externa</Title>
                <SubTitle>
                  DETECCIÓN DE SARS-CoV-2 RT-PCR
                </SubTitle>
              </div>
              <Hidden smDown>
                {messageBody}
              </Hidden>
            </DataWrapper>
          </Grid>
          <Hidden mdUp>
            {messageBody}
          </Hidden>
        </Body>
      </Container>
    </ResponsiveFonts>
  )
}

export default Header
